import { Link } from 'react-router-dom';
import { FiCheckCircle, FiMail } from 'react-icons/fi';

const CHAT_APP_URL = 'https://piuachatt.victriedemos.com';

export default function SuccessScreen({ accountType, username, email }) {
  return (
    <div className="card mx-auto flex max-w-lg flex-col items-center gap-4 p-10 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-success/10 text-success">
        <FiCheckCircle size={28} />
      </span>
      <h2 className="text-2xl font-bold text-ink dark:text-white">
        {accountType === 'organization' ? 'Your organization account is ready' : 'Your account is ready'}
      </h2>
      <p className="text-sm leading-relaxed text-muted dark:text-subtle">
        Payment was verified and your account has been created for <strong>{username}</strong> — every message will
        be automatically screened for sensitive information before it reaches the AI model.
      </p>

      <div className="flex items-start gap-2 rounded-xl border border-brand-200 bg-brand-gradient-soft p-4 text-left text-sm text-ink dark:border-brand-800/60 dark:text-white">
        <FiMail className="mt-0.5 flex-none text-brand-600 dark:text-brand-300" size={16} />
        <span>
          Your login details have been sent to <strong>{email}</strong> — sign in with the username above and the
          password you created.
        </span>
      </div>

      <div className="mt-2 flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
        <a href={CHAT_APP_URL} className="btn-primary">
          Log in to Piua AI
        </a>
        <Link to="/" className="btn-secondary">
          Back to home
        </Link>
      </div>
    </div>
  );
}
